import { FormControl, makeStyles } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useState } from 'react';

import { useDefaultValueWatcher } from '../../../hooks/useDefaultValueWatcher';
import InputField from '../TextField/TextField';

interface OwnProps {
  label?: string;
  placeholder?: string;
  options: AutocompleteOption[];
  onChange: (value: AutocompleteOption[]) => void;
  defaultValue?: AutocompleteOption[];
}

export interface AutocompleteOption {
  label: string;
  value: string;
}

const InputAutocomplete: React.FC<OwnProps> = ({
  label,
  placeholder,
  options,
  onChange,
  defaultValue = [],
}) => {
  const classes = useStyles();
  const [state, setState] = useState<AutocompleteOption[]>(defaultValue);

  useDefaultValueWatcher({ defaultValue, state, setState });

  return (
    <FormControl className={classes.formControl}>
      <Autocomplete
        multiple
        filterSelectedOptions={true}
        disableClearable={true}
        value={state}
        className={classes.autocomplete}
        onChange={(_, newValue: AutocompleteOption[]) => {
          onChange(newValue);
          setState([...newValue]);
        }}
        options={options}
        getOptionLabel={(option: AutocompleteOption) => option.label}
        renderTags={(tagValue: AutocompleteOption[], getTagProps: any) =>
          tagValue.map((option, index) => (
            <Chip
              key={index}
              label={option.label}
              {...getTagProps({ index })}
              className={classes.chip}
            />
          ))
        }
        renderInput={(params: any) => (
          <InputField {...params} label={label} placeholder={placeholder} />
        )}
      />
    </FormControl>
  );
};

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%',

    '& .MuiFormControl-root': {
      margin: 0,
    },
  },
  autocomplete: {
    width: '100%',
    '& .MuiInputBase-input': {
      padding: '0 10px !important',
    },
    '& .MuiInputBase-root': {
      padding: '0 !important',
    },
  },
  chip: {
    margin: theme.spacing(2),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '88%',
  },
}));

export default InputAutocomplete;
